import currency from "currency.js";
export var formatPrice = function formatPrice(price) {
  return currency(price / 100).format(true);
};